module.exports = __webpack_public_path__ + "img/img-5.07e7dcde.png";